import { cn } from '@/lib/utils'
import { RadioGroup as RadioGroupRadix } from 'radix-ui'

const RadioGroupItem = ({
  children,
  className,
  id,
  ...props
}: React.ComponentProps<typeof RadioGroupRadix.Item>) => (
  <div className="gap-xs flex items-center">
    <RadioGroupRadix.Item
      className={cn(
        'global-focus easing-none size-6 rounded-full border border-neutral-400 bg-white transition-all duration-100 outline-none hover:border-2 hover:border-neutral-600',
        className
      )}
      id={id}
      {...props}
    >
      <RadioGroupRadix.Indicator className="duration-default ease-out-cubic relative flex size-full items-center justify-center transition-all after:block after:size-[11px] after:rounded-full after:bg-neutral-600" />
    </RadioGroupRadix.Item>
    <label className="cursor-pointer" htmlFor={id}>
      {children}
    </label>
  </div>
)

RadioGroupItem.displayName = 'RadioGroupItem'

export default RadioGroupItem
